export const currencyToNumber = (value) => {
  if (typeof value === 'number') return value;
  if (!value) return 0;
  const removeCommas = value.replace(/,/g, '');
  return Number(removeCommas);
};

export const getNumberOfTransactions = (transactions) =>
  transactions
    ? Object.keys(transactions).filter((key) => currencyToNumber(transactions[key].amount) !== 0)
        .length
    : 0;
